import {
  api_autocomplete_entities_path,
  api_create_entity_path,
  api_top_entities_path,
} from '@routes';

import { AutocompleteRecord, CreateRecordResponse } from '../interfaces';
import request from './request';
import { getRecord } from './universal';

export const TOPIC_DESCRIPTION_KEY = 'TOPIC_DESCRIPTION_KEY';

export interface BasicEntity {
  id: number;
  name: string;
}

export interface TopEntity {
  id: number;
  name: string;
  following: boolean;
  topic_url: string;
}

export interface SanitizedAutocompleteEntityParams {
  fragment: string;
  entity_type?: string;
  word_type?: string;
  relationship_type?: string;
  order_entities_by?: string[];
  relationship_sources?: string[];
  match_type?: string;
}

export interface EntityBlurbRequestParams {
  entity_id: number;
}

export interface EntityBlurbResponse {
  blurb?: string;
  is_ai?: boolean;
  message?: string;
}

export const MATCH_EXACT = 'exact';
export const MATCH_SLUG = 'slug';
export const MATCH_FUZZY = 'fuzzy';

export async function autocompleteEntities(
  values: SanitizedAutocompleteEntityParams
): Promise<AutocompleteRecord[]> {
  const resp = await request('get', api_autocomplete_entities_path(values));
  return resp.entities;
}

export interface SanitizedEntityParams {
  name: string;
  entity_type: string;
  word_type: string;
}

export async function createEntity(values: SanitizedEntityParams): Promise<CreateRecordResponse> {
  const resp = await request('post', api_create_entity_path(values));
  return resp;
}

export async function getFollowedEntities(identityId: number | string): Promise<BasicEntity[]> {
  const resp = await getRecord({
    id: identityId,
    model: 'Identity',
    attributes: ['id'],
    relations: { followedEntities: { attributes: ['id', 'name'] } },
  });
  return resp.result?.followedEntities || [];
}

export async function getTopEntityOptions(): Promise<AutocompleteRecord[]> {
  const resp: { entities: TopEntity[] } = await request('get', api_top_entities_path());

  return resp.entities.map((entity) => ({
    label: entity.name,
    value: entity.id,
  }));
}
